import { render } from "./accountVerification.vue?vue&type=template&id=d3e2a634&scoped=true"
import script from "./accountVerification.vue?vue&type=script&lang=js"
export * from "./accountVerification.vue?vue&type=script&lang=js"

import "./accountVerification.vue?vue&type=style&index=0&id=d3e2a634&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3e2a634"]])

export default __exports__